/* unplugin-vue-components disabled */import script from "./CouponDetailInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CouponDetailInfo.vue?vue&type=script&setup=true&lang=js"

import "./CouponDetailInfo.vue?vue&type=style&index=0&id=c2836c44&lang=scss"

const __exports__ = script;

export default __exports__